import axiosInstance from "@/lib/axios";
import { icd10SearchPath } from "@/network/icd10SearchEndpoint";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { useDebounce } from "react-use";

interface Icd10SearchParams {
  searchText?: string;
  nested?: boolean;
  enabled?: boolean;
}

export interface Icd10CodeSearchResult {
  id: string;
  term: string;
  system: string;
  version: string;
  billable: boolean;
  level: number;
}

export const useIcd10Search = ({
  searchText,
  nested = false,
  enabled = true,
}: Icd10SearchParams) => {
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchText);
  useDebounce(
    () => {
      setDebouncedSearchText(searchText);
    },
    500,
    [searchText],
  );
  return useQuery<Icd10CodeSearchResult[]>({
    queryFn: async () => {
      const response = await axiosInstance.get(icd10SearchPath({ nested }), {
        params: {
          searchTerm: debouncedSearchText,
        },
      });

      return response.data?.matchedConcepts || [];
    },
    queryKey: [
      "medical-coding",
      "icd10",
      "search",
      nested ? "nested" : "flat",
      debouncedSearchText,
    ],
    enabled:
      enabled &&
      Boolean(debouncedSearchText && debouncedSearchText.length >= 2),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
